import { z } from "zod";
export const LibraryGroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  kind: z.enum(["folder", "collection"]),
});
export type LibraryGroup = z.infer<typeof LibraryGroupSchema>;
export const LibraryFilterSchema = z.object({
  missionId: z.string().min(1).max(100).optional(),
  view: z.enum(["all", "favorites", "trash"]).default("all"),
  folderId: z.string().max(200).optional(),
  collectionId: z.string().max(200).optional(),
  query: z.string().max(200).optional(),
});
export type LibraryFilter = z.infer<typeof LibraryFilterSchema>;
export const LibraryChangeSchema = z.object({
  ids: z.array(z.string().min(1).max(200)).min(1).max(100),
  action: z.enum(["favorite", "unfavorite", "move", "collect", "uncollect", "trash", "restore"]),
  groupId: z.string().min(1).max(200).optional(),
});
export type LibraryChange = z.infer<typeof LibraryChangeSchema>;
export const LibraryMetadataSchema = z.object({
  favorite: z.boolean(),
  folderId: z.string().nullable(),
  collectionIds: z.array(z.string()),
  trashedAt: z.string().nullable(),
});
export type LibraryMetadata = z.infer<typeof LibraryMetadataSchema>;
